export default __webpack_public_path__ + "68ec952b8a75166449ea879b4e3d984d.png";